import { CARD_TYPE_MAP, CardType } from './cardTypes';

/**
 * The label (plural & sentence case) used on product pages for each card type.
 */
export const LABEL_BY_CARD_TYPE: Record<CardType, string> = {
  // Envelopes
  [CARD_TYPE_MAP.envelope]: 'Envelopes',
  [CARD_TYPE_MAP.rsvpEnvelope]: 'RSVP envelopes',
  [CARD_TYPE_MAP.invitationEnvelope]: 'Invitation envelopes',
  // Add-ons
  [CARD_TYPE_MAP.paperAddOns]: 'Paper add-ons',
  [CARD_TYPE_MAP.bellyBand]: 'Paper add-ons',
  [CARD_TYPE_MAP.vellumJacket]: 'Paper add-ons',
  [CARD_TYPE_MAP.waxSeal]: 'Paper add-ons',
  // Primary card types
  [CARD_TYPE_MAP.matchingSuites]: 'Matching suites',
  [CARD_TYPE_MAP.invitation]: 'Invitations',
  [CARD_TYPE_MAP.std]: 'Save the dates',
  [CARD_TYPE_MAP.dstd]: 'Digital save the dates',
  [CARD_TYPE_MAP.ctd]: 'Change the dates',
  [CARD_TYPE_MAP.thankyou]: 'Thank you cards',
  [CARD_TYPE_MAP.menu]: 'Menus',
  [CARD_TYPE_MAP.program]: 'Programs',
  [CARD_TYPE_MAP.place]: 'Place cards',
  [CARD_TYPE_MAP.details]: 'Enclosures',
  [CARD_TYPE_MAP.enclosure]: 'Enclosures',
  [CARD_TYPE_MAP.holiday]: 'Holiday cards',
  [CARD_TYPE_MAP.weddingShower]: 'Wedding shower invitations',
  [CARD_TYPE_MAP.napkin]: 'Napkins',
  [CARD_TYPE_MAP.signage]: 'Signage',
  [CARD_TYPE_MAP.sticker]: 'Stickers',
  [CARD_TYPE_MAP.tableNumber]: 'Table numbers',
  // Secondary card types
  [CARD_TYPE_MAP.rsvp]: 'RSVPs',
} as const;

export const getLabelByCardType = (cardType?: CardType, isDigital?: boolean): string => {
  const updatedType = isDigital ? CARD_TYPE_MAP.dstd : cardType;
  return (updatedType && LABEL_BY_CARD_TYPE[updatedType]) || '';
};
